const INTERVIEW_STATUSES = {
  default: "default",
  invited: "invited",
  completed: "completed",
};

export default INTERVIEW_STATUSES;
